import React, { useState } from 'react';
import BookingModal from '../BookingModal';
import ContactForm from '../contact/ContactForm';
import ContactInfo from '../contact/ContactInfo';

const Contact: React.FC = () => {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  return (
    <section className="py-24 bg-white" id="contact">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12">
          <ContactInfo onBookingClick={() => setIsBookingModalOpen(true)} />
          <ContactForm />
        </div>
      </div>

      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
      />
    </section>
  );
};

export default Contact;